// 准备actions对象——响应组件中用户的动作
const actions = {
};
// 准备mutations对象——修改state中的数据
const mutations = {
};
// 准备state对象——保存具体的数据
const state = {
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
